import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit } from "@angular/core";
import { Observable, Subject, switchMap } from "rxjs";
import { distinctUntilChanged, filter, map } from "rxjs/operators";
import { AsyncPipe, NgFor, NgIf } from "@angular/common";
import { DataService } from "../../../core/providers/data/data.service";

import { ProductCardItem } from "../../../common/types";
import { toProductCardItem } from "../../../common/utils/to-product-card-item";
import { ProductCardComponent } from "../../../shared/components/product-card/product-card.component";
import { SectionHeaderComponent } from "../../../shared/components/section-header/section-header.component";
import { GET_PRODUCT_RECOMMENDATIONS } from "./related-products.graphql";

@Component({
    selector: 'kb-product-recommendations',
    templateUrl: './product-recommendations.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        NgIf,
        SectionHeaderComponent,
        NgFor,
        ProductCardComponent,
        AsyncPipe,
    ],
})
export class ProductRecommendationsComponent implements OnInit, OnChanges {
    @Input() productId: string;

    recommendations$: Observable<ProductCardItem[]>;
    private productId$ = new Subject<string>();

    constructor(private dataService: DataService) {}

    ngOnInit() {
        this.recommendations$ = this.productId$.pipe(
            distinctUntilChanged(),
            filter((productId) => !!productId),
            switchMap(() =>
                this.dataService.query(GET_PRODUCT_RECOMMENDATIONS, {
                    input: {
                        productId: this.productId,
                        recommendationStrategy: 'similar-facet-values',
                        take: 12,
                    },
                }, { ssr: true }),
            ),
            map((data) => data.productRecommendations.map(toProductCardItem)),
        );
    }

    ngOnChanges() {
        this.productId$.next(this.productId);
    }
}
